/* eslint-disable import/first */
import React from 'react';
const { selectDesktop } = Slices.appSlice;
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { useNavigate } from '@reach/router';
import Header from '../../components/Header';
import BackButton from '../../components/BackButton';

import LanguageButton from '../../components/LanguageButton';
import css from './index.module.scss';

import SavedCards from './SavedCards';
import { FormattedMessage, useIntl } from 'react-intl';

const MySavedCards = () => {
  const isDesktop = useSelector(selectDesktop);
  const navigate = useNavigate();
  const intl = useIntl();
  const handleBack = () => {
    navigate(`/${intl.locale}/home`);
  };
  return (
    <div className={css.cardsMain}>
      {!isDesktop ? (
        <Header
          title={<FormattedMessage id="my_saved_cards" defaultMessage="My Saved Cards" />}
          actionButtons={[<LanguageButton />]}
        />
      ) : (
        <div className={css.header}>
          <div className={css.mainHeading}>
            <FormattedMessage id="my_saved_cards" defaultMessage="My Saved Cards" />
          </div>
          <BackButton handleBack={handleBack} type="cross" />
        </div>
      )}
      <SavedCards />
    </div>
  );
};

export default MySavedCards;
